import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Products from "@/components/site/Products";
import Pricing from "@/components/site/Pricing";
import Blog from "@/components/site/Blog";
import WhyUs from "@/components/site/WhyUs";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingButtons from "@/components/site/FloatingButtons";

const HomePage = () => (
  <div data-testid="home-page" className="min-h-screen bg-[#F8FAFC] text-[#0F172A]">
    <Navbar />
    <main>
      <Hero />
      <Products />
      <Pricing />
      <WhyUs />
      <Blog />
      <About />
      <Contact />
    </main>
    <Footer />
    <FloatingButtons />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
